module.exports = __webpack_public_path__ + "img/txsrmyy.26fe3e6e.png";